/**
 * How the app is running, from the main thread (the worker cannot see `window`).
 *
 * On iOS the thing that actually governs storage eviction is whether the app was
 * launched from the Home Screen, NOT `navigator.storage.persisted()`. WebKit does
 * not implement the Storage Standard's persistence grant the way Chromium does and
 * reports `false` regardless, so that value is recorded but must not be presented
 * as a verdict.
 */
export interface InstallState {
  standalone: boolean;
  /** Which signal said so, so the reading can be sanity-checked rather than trusted. */
  source: string;
  isIos: boolean;
}

export function installState(): InstallState {
  const byMedia = typeof matchMedia === 'function'
    && matchMedia('(display-mode: standalone)').matches;
  // iOS-only legacy flag; still the most reliable signal on Safari.
  const byLegacy = (navigator as unknown as { standalone?: boolean }).standalone === true;
  const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const sources = [byMedia && 'display-mode', byLegacy && 'navigator.standalone']
    .filter(Boolean) as string[];
  return {
    standalone: byMedia || byLegacy,
    source: sources.length ? sources.join(' + ') : 'neither signal set',
    isIos,
  };
}
